import ApiService from "@/common/api/api.service";

let endpoint = "ProjetoGestao";

const Atividades = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    buscarAtividade(atividade,realizado, id){
        return ApiService.get(`${endpoint}/atividade-${atividade}-${realizado ? "realizado" : "previsto"}?projetoGestaoId=${id}`);
    },

    salvarAtividade(atividade,realizado, form)
    {
        return ApiService.put(`${endpoint}/atividade-${atividade}-${realizado ? "realizado" : "previsto"}`, form);
    }

}

export default Atividades;
